import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import WebsiteDevelopment from "@/pages/WebsiteDevelopment";
import SoftwareDevelopment from "@/pages/SoftwareDevelopment";
import BusinessManagement from "@/pages/BusinessManagement";
import SeoSmo from "@/pages/SeoSmo";
import DigitalMarketing from "@/pages/DigitalMarketing";
import Pricing from "@/pages/Pricing";
import Process from "@/pages/Process";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import RefundPolicy from "@/pages/RefundPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import PaymentInformation from "@/pages/PaymentInformation";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminInbox from "@/pages/admin/AdminInbox";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
};

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <ScrollToTop />
      <SmoothScroll />
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <main id="main-content" className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/website-development" element={<WebsiteDevelopment />} />
            <Route path="/software-development" element={<SoftwareDevelopment />} />
            <Route path="/business-management" element={<BusinessManagement />} />
            <Route path="/seo-smo" element={<SeoSmo />} />
            <Route path="/digital-marketing" element={<DigitalMarketing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/process" element={<Process />} />
            <Route path="/portfolio" element={<Navigate to="/services" replace />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/payment-information" element={<PaymentInformation />} />
            <Route path="/enquiry" element={<Navigate to="/contact" replace />} />
            <Route path="/it-support/*" element={<Navigate to="/services" replace />} />
            <Route path="/devices-a" element={<Navigate to="/services" replace />} />
            <Route path="/devices-b" element={<Navigate to="/services" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminInbox /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
      </div>
      <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
